import AppEnvironment from '../../../components/enums/appEnvironment.enum';
import {
  APP_ENVIRONMENT_HEADER_KEY,
  BRAND_ID_HEADER_KEY,
  TEAM_ID_HEADER_KEY,
  restApi,
} from '../../api';
import { GetOfflineEncryptionKeyOptions, GetOfflineEncryptionKeyOutput } from './offline.types';

const PATH = 'offline';

export const getOfflineEncryptionKey = ({
  overrideHeaderParams,
}: GetOfflineEncryptionKeyOptions = {}) =>
  restApi.get<GetOfflineEncryptionKeyOutput>(`${PATH}/key`, undefined, {
    headers: !overrideHeaderParams
      ? undefined
      : {
          [TEAM_ID_HEADER_KEY]: overrideHeaderParams.teamId,
          [BRAND_ID_HEADER_KEY]: overrideHeaderParams.brandId,
          [APP_ENVIRONMENT_HEADER_KEY]: AppEnvironment.BRAND,
        },
  });
